<template>
	<div class="login-container d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-transparent ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Sign up
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="flex-shrink-0 container">
			<form class="form-signin card">
				<h5 class="text-left mb-3">Forgot Email/Password</h5>
				<div class="form-group">
					<p id="emailHelp" class="form-text ">
						How would you like to reset your password?
					</p>
				</div>
				<div class="form-group">
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="customRadio2"
							name="customRadio"
							class="custom-control-input"
							value="email"
							v-model="picked"
						/>
						<label
							class="custom-control-label text-capitalize"
							for="customRadio2"
							>Email</label
						>
					</div>
				</div>
				<div class="form-group">
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="customRadio1"
							name="customRadio"
							class="custom-control-input"
							value="phone"
							v-model="picked"
						/>
						<label
							class="custom-control-label text-capitalize"
							for="customRadio1"
							>Text Message (SMS)</label
						>
					</div>
				</div>
				<div v-if="picked == 'email'">
					<div class="form-froup">
						<p>
							We will send you an email with instructions on how to reset your
							password.
						</p>
					</div>
					<div class="form-group">
						<input
							type="email"
							class="form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							placeholder="example@email.com"
							v-model="useridEmail"
							@focus="emailFocus"
						/>
						<label class="text-center pt-3" v-if="showEmailValid"
							>Invalid Email</label
						>
					</div>
					<button
						class="btn btn-primary btn-block text-uppercase"
						v-on:click.stop.prevent="forgotpassword"
					>
						Email ME
					</button>
				</div>
				<div v-if="picked == 'phone'">
					<div class="form-group">
						<p>
							We will text you a verification code to reset your password. Text
							fees may apply.
						</p>
					</div>
					<div class="input-group mb-3">
						<div class="input-group-prepend">
							<button
								class="btn btn-light dropdown-toggle"
								type="button"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								({{ countryCode }}) {{ countryName }}
							</button>
							<div class="dropdown-menu">
								<a
									class="dropdown-item"
									href="#"
									v-for="(countrycode, index) in countrycodes"
									:key="index"
									@click="onCountryCodeClicked(countrycode)"
									>({{ countrycode["country_code"] }})
									{{ countrycode["country_name"] }}</a
								>
							</div>
						</div>
						<input
							type="text"
							class="form-control"
							aria-label="Text input with dropdown button"
							v-model="useridPhone"
						/>
					</div>
					<label class="text-center pt-3" v-if="showPhoneValid"
						>Invalid Phone</label
					>
					<button
						class="btn btn-primary btn-block text-uppercase"
						v-on:click.stop.prevent="forgotpassword"
					>
						TEXT ME
					</button>
				</div>
			</form>
			<p class="text-center text-white pt-4">Download App</p>
			<p class="text-center text-white">
				<img
					src="../../assets/img/google-play.png"
					class="cursor-pointer"
					alt=""
					@click="gotoAppStore('google')"
				/>
				<img
					src="../../assets/img/app-store.png"
					class="ml-2 cursor-pointer"
					alt=""
					@click="gotoAppStore('apple')"
				/>
			</p>
		</section>
		<!-- Footer -->
		<footer class="footer mt-auto py-3">
			<!-- Footer Links -->
			<div class="container text-center">
				<a href="/#/">Home</a>
				<a href="/#/cookiesprivacy">Privacy Policy</a>
				<a href="/#/terms">Terms of Use</a>
				<a href="/#/faqs">FAQ</a>
			</div>
			<!-- Footer Links -->
			<!-- Copyright -->
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
			<!-- Copyright -->
		</footer>
		<!-- Footer -->
	</div>
</template>

<style scoped>

.login-container .dropdown-menu {
	height: 10rem;
	overflow-x: hidden !important;
	overflow-y: scroll !important;
	min-width: 115px !important;
	width: 115px !important;
}

</style>

<script>
import CountryCodes from "@/assets/json/CountryCodes.json";
export default {
	name: "forgotPasswordEmail",
	components: {},
	watch: {
		useridPhone(newval, oldval) {
			if (newval.length > 11) {
				this.useridPhone = oldval;
			}
		},
	},
	created() {
		this.picked = "email";
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
		const config = this.$store.getters.getGlobalConfigs;
		var cont = CountryCodes.find((con) => {
			return con.country_name == config.country_code;
		});
		this.countryCode = cont.country_code;
		this.countryName = cont.country_name;
	},
	methods: {
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		gotoSingin() {
			this.$router.push("/signup");
		},
		gotoEmailVerify() {
			this.$router.push("/verifybyemail");
		},
		goToTextVerify() {
			this.$router.push("/verifybyphone");
		},
		onCountryCodeClicked(countrycode) {
			this.countryCode = countrycode.country_code;
			this.countryName = countrycode.country_name;
		},
		emailFocus() {
			this.showEmailValid = false;
		},
		phoneFocus() {
			this.showPhoneValid = false;
		},
		ValidateEmail() {
			var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (this.useridEmail.match(mailformat)) {
				return true;
			} else {
				this.showEmailValid = true;
				return false;
			}
		},
		ValidatePhone() {
			var phoneno = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
			if (this.useridPhone.match(phoneno)) {
				return true;
			} else {
				this.showPhoneValid = true;
				return false;
			}
		},
		forgotpassword() {
			this.isActive = true;
			this.showforgotpasswordErr = false;

			if (this.doforgotpassword) {
				if (this.picked == "email" && this.ValidateEmail() == true) {
					var dataToSend = {
						email: this.useridEmail,
					};
				} else if (this.picked == "phone" && this.ValidatePhone() == true) {
					var dataToSend = {
						telephone: this.countryCode + "" + this.useridPhone,
					};
				}
				var self = this;
				this.$store.commit("setLoader", true);
				this.$store
					.dispatch("forgetpassword", dataToSend)
					.then((res) => {
						if (res) {
							this.$store.commit("setLoader", false);
							self.showforgotpasswordErr = true;
							this.$store.commit("setNotification", res.message);
							if (self.picked == "email") {
								this.$store.commit("updateResetField", {
									type: "email",
									value: self.useridEmail,
								});
								this.$store.commit("updateResetField", {
									type: "token",
									value: res.token,
								});
								res.message;
								this.$router.push("/");
							} else if (self.picked == "phone") {
								this.$store.commit("updateResetField", {
									type: "telephone",
									value: self.useridPhone,
								});
								this.$store.commit("updateResetField", {
									type: "token",
									value: res.token,
								});
								this.$router.push("/updatepassword-en/tl/");
							}
						}
					})
					.catch((err) => {
						this.$store.commit("setLoader", false);
						this.showforgotpasswordErr = true;
						this.forgotpasswordErr = err.response.data.error.message;
					});
			}
		},
	},

	data() {
		return {
			picked: "email",
			showforgotpasswordErr: false,
			forgotpasswordErr: "",
			isActive: false,
			doforgotpassword: true,
			userid: "",
			useridPhone: "",
			useridEmail: "",
			password: "",
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
			showEmailValid: false,
			showEmailValidErr: "Invalid Email",
			showPhoneValid: false,
			showPhoneValidErr: "Invalid Phone",
			countrycodes: CountryCodes,
			countryCode: "",
			countryName: "",
		};
	},
};
</script>
